export default __webpack_public_path__ + "static/15solaris-97510d37b71c6d1195fe1e7f5fa499e7.png";